import { render, staticRenderFns } from "./Toggler.vue?vue&type=template&id=455a3f8a&scoped=true"
import script from "./Toggler.vue?vue&type=script&lang=js"
export * from "./Toggler.vue?vue&type=script&lang=js"
import style0 from "./Toggler.vue?vue&type=style&index=0&id=455a3f8a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a3f8a",
  null
  
)

export default component.exports